import { SortType, AscType } from 'commons/constants/type';
import ScriptGroupParamVO from 'commons/vo/param/WkblScriptParamVO';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  changeWkblScriptAsc,
  changeWkblScriptPage,
  changeWkblScriptReturnCount,
  changeWkblScriptSort,
  clearWkblScriptList,
  requestWkblScriptList,
} from 'redux/actions/actions';
import { RootState } from 'redux/reducers/type';

export default function useWkblScript() {
  const dispatch = useDispatch();

  const onRequestWkblScriptList = useCallback(
    (param: ScriptGroupParamVO) => {
      dispatch(requestWkblScriptList({ param }));
    },
    [dispatch],
  );

  const onClearWkblScriptList = useCallback(() => {
    dispatch(clearWkblScriptList());
  }, [dispatch]);

  const onChangeWkblScriptPage = useCallback(
    (pageNumber: number) => {
      dispatch(changeWkblScriptPage({ pageNumber }));
    },
    [dispatch],
  );

  const onChangeWkblScriptSort = useCallback(
    (sort: SortType) => {
      dispatch(changeWkblScriptSort({ sort }));
    },
    [dispatch],
  );
  const onChangeWkblScriptAsc = useCallback(
    (asc: AscType) => {
      dispatch(changeWkblScriptAsc({ asc }));
    },
    [dispatch],
  );

  const onChangeWkblScriptReturnCount = useCallback(
    (returnCount: number) => {
      dispatch(changeWkblScriptReturnCount({ returnCount }));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      onRequestWkblScriptList,
      onClearWkblScriptList,
      onChangeWkblScriptPage,
      onChangeWkblScriptSort,
      onChangeWkblScriptAsc,
      onChangeWkblScriptReturnCount,
    }),
    [
      onRequestWkblScriptList,
      onClearWkblScriptList,
      onChangeWkblScriptPage,
      onChangeWkblScriptSort,
      onChangeWkblScriptAsc,
      onChangeWkblScriptReturnCount,
    ],
  );
}
